export const getAppStore = (url: string) => {
  return url.includes("apple.com") ? "apple" : "google";
};

export const getStoreLinkId = (link: string): string | null => {
  try {
    if (link.includes("apple")) {
      const start = link.lastIndexOf("id") + 2;
      const end =
        link.indexOf("?", start) !== -1
          ? link.indexOf("?", start)
          : link.length;
      return link.substring(start, end).trim();
    }
    if (link.includes("google")) {
      const start = link.indexOf("id=") + 3;
      const end =
        link.indexOf("&", start) !== -1
          ? link.indexOf("&", start)
          : link.length;
      return link.substring(start, end).trim();
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};
